import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgArrowDown = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1.47 13.75 10 10a.68.68 0 0 0 1 0l10-10a.76.76 0 0 0 .22-.5.74.74 0 0 0-.22-.49l-1.07-1.08a.76.76 0 0 0-.5-.22.72.72 0 0 0-.49.22l-7 7V.7a.75.75 0 0 0-.2-.5.7.7 0 0 0-.5-.2h-1.47a.77.77 0 0 0-.51.2.75.75 0 0 0-.2.5v18l-7-7a.74.74 0 0 0-.53-.24.7.7 0 0 0-.5.22l-1.03 1.08a.74.74 0 0 0-.22.49.76.76 0 0 0 .22.5"
    }));
export default SvgArrowDown;
